import { apiGet, apiSend, USE_MOCK_API } from './httpClient'

export interface DriveFile {
  file_id: string
  name: string
  mime_type: string
  size_bytes: number | null
  modified_at: string | null
  thumbnail_link: string | null
}

export interface ImportedDocument {
  id: string
  name: string
  file_url: string
  is_media: boolean
}

const MOCK_FILES: DriveFile[] = [
  {
    file_id: 'drv_demo_001',
    name: 'Flight_TLV_FCO_Confirmation.pdf',
    mime_type: 'application/pdf',
    size_bytes: 104_000,
    modified_at: '2026-07-01',
    thumbnail_link: null,
  },
  {
    file_id: 'drv_demo_002',
    name: 'Hotel_Colosseum_Booking.pdf',
    mime_type: 'application/pdf',
    size_bytes: 88_000,
    modified_at: '2026-07-02',
    thumbnail_link: null,
  },
  {
    file_id: 'drv_demo_003',
    name: 'Rome_Itinerary.docx',
    mime_type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    size_bytes: 256_000,
    modified_at: '2026-07-03',
    thumbnail_link: null,
  },
  {
    file_id: 'drv_demo_004',
    name: 'Trip_Photo_Colosseum.jpg',
    mime_type: 'image/jpeg',
    size_bytes: 512_000,
    modified_at: '2026-07-04',
    thumbnail_link: null,
  },
]

export async function listDriveFiles(tripId: string, q?: string): Promise<DriveFile[]> {
  if (USE_MOCK_API) {
    if (q) return MOCK_FILES.filter((f) => f.name.toLowerCase().includes(q.toLowerCase()))
    return MOCK_FILES
  }
  const params = q ? `?q=${encodeURIComponent(q)}` : ''
  return apiGet<DriveFile[]>(`/trips/${tripId}/import/drive/files${params}`)
}

export async function importDriveFiles(
  tripId: string,
  fileIds: string[],
): Promise<ImportedDocument[]> {
  if (USE_MOCK_API) {
    return fileIds.map((id) => {
      const file = MOCK_FILES.find((f) => f.file_id === id)
      return {
        id: `doc_${id}`,
        name: file?.name ?? id,
        file_url: `trips/${tripId}/documents/${id}`,
        is_media: file?.mime_type.startsWith('image/') ?? false,
      }
    })
  }
  return apiSend('POST', `/trips/${tripId}/import/drive`, { file_ids: fileIds })
}
